const breakpointValues = {
  xs: 0,
  sm: 768,
  md: 1200,
  lg: 1536,
  xl: 1920,
};

export default breakpointValues;
